import { Button, styled } from "@mui/material";

export const ButtonStyled = styled(Button)(({ theme }) => ({
  padding: "16px 32px",
  borderRadius: "100px",
  boxShadow: "unset",
  whiteSpace: "nowrap",
}));
